export type UseTitleProps = {
  enabled: boolean;
  title?: string;
}

export function useTitle({ enabled, title }: UseTitleProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <title>{title}</title>
    </>
  )
}